import { Injectable } from '@angular/core'
import { Request, XHRBackend, RequestOptions, Response, Http, RequestOptionsArgs, Headers } from '@angular/http'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/catch'
import 'rxjs/add/observable/throw'
import { Router } from '@angular/router'


@Injectable()
export class AuthenticatedHttpService extends Http {

  constructor(backend: XHRBackend, defaultOptions: RequestOptions, private router: Router) {
    super(backend, defaultOptions)
  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    if (typeof url !== 'string') {
      url.headers.append('X-APP-RELAYSTATE', location.href)
    }
    return super.request(url, { withCredentials: true })
    .catch((error: Response) => {
      if (error.status === 401) {
        const body = document.body
        body.innerHTML = error.text()
        const form: any = body.firstChild
        form.submit()
      }
      else if (error.status === 403) {
        this.router.navigateByUrl('/error/403')
      }
      else if (error.status >= 400) {
        if (error.headers.get('content-type').indexOf('text/html') !== -1) { // Si es HTML
          const mensaje = `Mensaje: ${error.statusText}, código: ${error.status}`
          const err = { errores: [{ mensaje: mensaje }]}
          dispatchEvent(new CustomEvent('errorRespuesta', { detail: err }))
        }
        else { // Si es JSON
          dispatchEvent(new CustomEvent('errorRespuesta', { detail: error.json() }))
        }
      }
      return Observable.throw(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/interceptor/interceptor.ts